import { useMemo } from 'react';
import { useChainId } from 'src/hooks/chain';
import { useStoreType } from 'src/hooks/useStoreType';
import { StoreFurnitureModel } from 'src/infrastructure/rest-api/api-types';
import { useApiQuery } from 'src/infrastructure/rest-api/useApi';

export const useChainStoresInventoryQuery = (storefrontType: string) => {
    const chainId = useChainId();
    const storeType = useStoreType();

    const { data, loading, error } = useApiQuery('/api/inventorymanagement/chains/{chainId}/stores', 'get', {
        path: {
            chainId: Number(chainId),
        },
        query: {
            storeType,
            storefrontType,
        },
        enabled: !!chainId && !Number.isNaN(Number(chainId)) && !!storefrontType,
    });

    const lookup = useMemo<Map<number, Map<number, StoreFurnitureModel>>>(() => {
        const map = new Map<number, Map<number, StoreFurnitureModel>>();
        for (const inventory of data ?? []) {
            const inventoryMap = map.get(inventory.storeId) ?? new Map<number, StoreFurnitureModel>();
            inventoryMap.set(inventory.chainFurnitureId, inventory);
            map.set(inventory.storeId, inventoryMap);
        }
        return map;
    }, [data]);

    return {
        data,
        lookup,
        loading,
        error,
    };
};
